import {getEventId, getEventTitle} from '@wix/wix-events-commons-statics'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {getEventDateInformation, isMultiDay} from '../../../../../../../../../commons/selectors/event'
import {useWidgetState} from '../../../../../../hooks/state-provider'
import {getMultiDayText} from '../../../../../../selectors/events'
import s from './day-events.scss'
import {DayEventsProps} from './interfaces'

export const DayEvents = ({events, currentDate}: DayEventsProps) => {
  const {t} = useTranslation()
  const firstEvent = events[0]

  const firstEventTime = useWidgetState(state => getEventDateInformation(state, getEventId(firstEvent))).startTime
  const multiDay = useWidgetState(state => isMultiDay(state, firstEvent))
  const multiDayText = useWidgetState(state => getMultiDayText(state, getEventId(firstEvent), currentDate, t))

  return (
    <div className={s.info}>
      <div className={s.fullEvents}>
        <div className={s.time} data-hook="cell-event-time">
          {multiDay ? multiDayText : firstEventTime}
        </div>
        <div className={s.title}>
          <div className={s.titleContent} data-hook="cell-event-title">
            {getEventTitle(events[0])}
          </div>
        </div>
        {events.length > 1 ? (
          <div className={s.more} data-hook="more-link">
            {t('layout.calendar.monthly.events.moreLink', {amount: events.length - 1})}
          </div>
        ) : null}
      </div>
      <div className={classNames(s.compactEvents, s.more)} data-hook="more-link">
        {t('layout.calendar.monthly.events.moreLink', {amount: events.length})}
      </div>
    </div>
  )
}
